module.exports = __webpack_public_path__ + "images/file_icons_v2/rom-042ed045e1b5a577134a9d36e7736beb.svg";